// D:\brickbucket_v3.1\Brickbucket_Frontend_V3.1\src\ConsumerApp\api\categories\category.hooks.js

import { useQuery } from '@tanstack/react-query';
import { CategoryService } from './category.service';

export const useGetCategories = () => {
  return useQuery({
    queryKey: ['categories'],
    queryFn: async () => {
      const response = await CategoryService.getCategories();
      return response?.data || response;
    },
    staleTime: 1000 * 60 * 5,
    retry: 2,
  });
};